import * as THREE from 'three';
import PolyMesh from '../../polyMesh/geometric/model/PolyMesh';
import PolyMap from '../../polyMesh/geometric/model/PolyMap';
import ObjectArrayView from '../../polyMesh/generic/container/ObjectArrayView';

const ScaleMode = {
  Scale: 0,
  Tiling: 1,
};

const UVTransform = {
  name: 'UVTransform',
  label: 'UV Transform',

  schema: {
    rotation: { label: 'Rotation', type: 'Number', step: 0.1,  minValue: -360, maxValue: 360, defaultValue: 0, animatable: true },
    scaleMode: { label: 'Scale Mode', type: 'Options', display: 'Dropdown',
                labels: ['Scale', 'Tiling'],
                values: [ScaleMode.Scale, ScaleMode.Tiling],
                defaultValue: ScaleMode.Scale, },
    tiling: { label: 'Tiling', type: 'Vec2', step: 0.1, defaultValue: new THREE.Vector2(1, 1), animatable: true },
    scale: { label: 'Scale', type: 'Vec2', step: 0.1, defaultValue: new THREE.Vector2(1, 1), animatable: true },
    translation: { label: 'Translation', type: 'Vec2', step: 0.1, defaultValue: new THREE.Vector2(0, 0), animatable: true },
    pivotCenter: { label: 'Pivot Center', type: 'Vec2', step: 0.1, defaultValue: new THREE.Vector2(0, 0), animatable: true },

    uvMapChannel: { label: 'UV Channel', type: 'String', defaultValue: 'default' },

  },

  update: function (operator, primitive) {

    const mesh = primitive.mesh;
    if (!mesh) return primitive;

    const mapChannel = operator.uvMapChannel || 'default'; //consider empty channel as default

    const uvMap = mesh.uvMaps ? mesh.uvMaps.byName[mapChannel] : null;
    if (!uvMap) return primitive;

    const uvVec3 = new THREE.Vector3();
    const uv = new THREE.Vector2();
    const uvValues = new ObjectArrayView(THREE.Vector2, uvMap.values.length);

    const rotation = operator.rotation;
    const scaleMode = operator.scaleMode;
    const scale = operator.scale;
    const tiling = operator.tiling;
    const translation = operator.translation;
    const pivotCenter = operator.pivotCenter;

    const uvTransform = getUVTransform(rotation, tiling, (scaleMode  === ScaleMode.Scale), scale, translation, pivotCenter);

    for (let i = 0; i < uvMap.values.length; i++) {
      uvMap.values.getAt(i, uv);
      uvVec3.set(uv.x, uv.y, 0);
      uvVec3.applyMatrix4(uvTransform);
      uv.set(uvVec3.x, uvVec3.y);
      uvValues.setAt(i, uv);
    }

    const resultMesh = new PolyMesh(mesh);

    const newUVMap = new PolyMap({
      faceRangeOffsets: mesh.faceRangeOffsets,
      faceValueIndices: uvMap.faceValueIndices,
      values: uvValues,
    });

    resultMesh.uvMaps.set(mapChannel, newUVMap);

    primitive.mesh = resultMesh;
  },
};

function getUVTransform(rotation, tiling, useScale, scale, translation, pivotCenter) {

  const result = new THREE.Matrix4();

  result.multiply(new THREE.Matrix4().makeTranslation(pivotCenter.x, pivotCenter.y, 0));
  result.multiply(new THREE.Matrix4().makeRotationZ(THREE.Math.degToRad(rotation)));
  if (useScale) {
    result.multiply(new THREE.Matrix4().makeScale(scale.x, scale.y, 0));
  } else {
    const safeInverse = function (v) {
      return (v == 0) ? 1 : 1 / v;
    };

    result.multiply(new THREE.Matrix4().makeScale(safeInverse(tiling.x), safeInverse(tiling.y), 0));
  }

  result.multiply(new THREE.Matrix4().makeTranslation(-pivotCenter.x, -pivotCenter.y, 0));
  result.multiply(new THREE.Matrix4().makeTranslation(translation.x, translation.y, 0));

  return result;

};

export default UVTransform;



// WEBPACK FOOTER //
// ./src/operators/PolyMesh/UVTransform.js